@if (backupModel && backupModel.createdOn) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>{{ "detailMain.summaryIdentifier" | t }}</b> {{ backupModel.identifier }}</div>
                <div class="property">
                    <b>{{ "detailMain.summaryDateCreated" | t }}</b> {{ backupModel.createdOn | dateTimeFormat }}
                </div>
            </div>
            <div class="col-6">
                <div class="property"><b>{{ "detailMain.summaryCreatedBy" | t }}</b> {{ backupModel.createdBy }}</div>
                <div class="property"><b>{{ "detailMain.summaryModifiedBy" | t }}</b> {{ backupModel.modifiedBy }}</div>
            </div>
        </div>
    </div>
}

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ "detailMain.detailsTitle" | t }}</div>
    <div class="detail-page-card-body padded form-group-styling">
        <form [formGroup]="parentFormGroup">
            <div class="row">
                <div class="col-6">
                    <cerrix-textfield
                        [fieldLabel]="'detailMain.findingName' | t"
                        identifier="findingNameInput"
                        formControlName="findingName"
                        dataUiid="audit-finding-name"
                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                    ></cerrix-textfield>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="auditeeSelect">{{ "detailMain.auditees" | t }}</label>
                        <cerrix-select
                            id="auditeeSelect"
                            [multiple]="true"
                            dataUiid="audit-finding-auditee"
                            formControlName="findingAuditees"
                            [prettyName]="'detailMain.auditees' | t"
                            [getDataMethod]="auditeeRequest$"
                            bindValue="ID"
                            bindLabel="Name"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <cerrix-textarea
                        dataUiid="audit-finding-findingdescription"
                        [fieldLabel]="'detailMain.findingDescription' | t"
                        formControlName="findingDescription"
                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                    ></cerrix-textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <cerrix-textarea
                        dataUiid="audit-finding-root-cause"
                        [fieldLabel]="'detailMain.rootCause' | t"
                        formControlName="rootCause"
                    ></cerrix-textarea>
                </div>
                <div class="col-6">
                    <cerrix-textarea
                        dataUiid="audit-finding-recommendation"
                        [fieldLabel]="'detailMain.recommendation' | t"
                        formControlName="recommendation"
                    ></cerrix-textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-6 form-group">
                    <label for="auditFindingSeverity">{{ "detailMain.severity" | t }}</label>
                    <cerrix-select
                        id="auditFindingSeverity"
                        [prettyName]="'detailMain.severityPrettyName' | t"
                        bindValue="ID"
                        bindLabel="Name"
                        formControlName="severityId"
                        [getDataMethod]="getSeverities()"
                        dataUiid="audit-finding-severity-select"
                    >
                    </cerrix-select>
                </div>
                <div class="col-6 form-group">
                    <label for="auditFindingFollowUp">{{ "detailMain.followUp" | t }}</label>
                    <cerrix-select
                        id="auditFindingFollowUp"
                        [prettyName]="'detailMain.followUp' | t"
                        bindValue="ID"
                        bindLabel="Name"
                        formControlName="followUpIds"
                        [getDataMethod]="getFollowUpData()"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        dataUiid="audit-finding-followup-select"
                    >
                    </cerrix-select>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <cerrix-textarea
                        dataUiid="audit-finding-comment"
                        [fieldLabel]="'detailMain.comment' | t"
                        formControlName="comment"
                    ></cerrix-textarea>
                </div>
                <div class="col-6">
                    <cerrix-textarea
                        dataUiid="audit-finding-managementResponse"
                        [fieldLabel]="'detailMain.managementResponse' | t"
                        formControlName="managementResponse"
                        [readonly]="!permissions.canEditManagementResponse"
                    ></cerrix-textarea>
                </div>
            </div>
        </form>
    </div>
</div>
